// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"a41d809e","543":"aec1ee43","615":"fc579876"}[chunkId] + ".chunk.js";
};